import ProfileIcon from "@/assets/icons/ProfileIcon.svg";
import LogoutIcon from "@/assets/icons/LogoutIcon.svg";

export const settingsLinks = [
  {
    text: "headNav.userProfile.profile",
    route: "/admin/settings/profile",
    name: "profile",
    icon: ProfileIcon,
  },
  {
    text: "headNav.logout",
    route: "/",
    name: "logout",
    icon: LogoutIcon,
  },
];

export const adminNavItems = [
  {
    text: "headNav.admin.organizations",
    route: "/admin/organizations",
    name: "organizations",
  },
  {
    text: "headNav.admin.users",
    route: "/admin/users",
    name: "users",
  },
  {
    text: "headNav.admin.carePlans",
    route: "/admin/careplans",
    name: "careplans",
  },
  {
    text: "headNav.admin.contentManagement",
    route: "/admin/assets",
    name: "assets",
  },
  {
    text: "headNav.settings",
    route: "",
    name: "settings",
    subItems: settingsLinks,
  },
];

export const organizationLinks = [
  {
    text: "headNav.adminOrgs.info",
    route: "org-profile",
    name: "org-profile",
  },
  {
    text: "headNav.adminOrgs.users",
    route: "org-users",
    name: "org-users",
  },
  {
    text: "headNav.adminOrgs.orgCarePlans",
    route: "org-careplans",
    name: "org-careplans",
  },
  {
    text: "headNav.adminOrgs.orgContent",
    route: "org-assets",
    name: "org-assets",
  },
  {
    text: "headNav.adminOrgs.orgPredefined",
    route: "predefined-action-items",
    name: "predefined-action-items",
  },
];
